<template>
  <div class="container" @mousemove="monitor()">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="title">留言内容管理</div>
        <div class="typeList">
          <div v-for="(item, i) in typeList" :key="i">
            <span @click="chanetype(item, i)" :class="item.active ? 'active' : ''">{{ item.name }}</span>
            <el-divider direction="vertical"></el-divider>
          </div>
        </div>
      </div>
      <div>
        <el-button-group>
          <el-button @click="removeSelected()">删除</el-button>
          <!-- <el-button>删除全部</el-button> -->
        </el-button-group>
        <el-button-group>
          <el-button @click="publishSelected">显示</el-button>
          <el-button @click="unpublishSelected">隐藏</el-button>
        </el-button-group>
        <el-table ref="multipleTable" :data="messageList" border tooltip-effect="dark" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column prop="title" label="留言标题" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="username" label="姓名">
          </el-table-column>
          <el-table-column prop="telephone" label="手机号">
          </el-table-column>
          <el-table-column prop="type" label="类别">
          </el-table-column>
          <el-table-column label="是否已回复">
            <template slot-scope="scope">
              <span style="color:#9D49C6" v-if="scope.row.status == 1">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span style="color:#9D49C6" v-if="scope.row.isPublish == 1">已显示</span>
              <span v-else>未显示</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="留言时间">
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <i class="el-icon-edit-outline" title="回复" @click='reply(scope.row)'></i>
              <i class="el-icon-delete" @click="remove(scope.row)"></i>
              <i class="el-icon-view" title="查看详情" @click="showDetail(scope.row)"></i>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="操作"
            width="120">
            <template slot-scope="scope">
              <i class="el-icon-edit-outline" title="回复"  v-if="scope.row.status != 1" @click='reply(scope.row)'></i>
              <i class="el-icon-delete" @click="remove(scope.row)"></i>
              <i class="el-icon-view" title="查看详情" @click="showDetail(scope.row)"></i>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" layout=" prev, pager, next, total, sizes, jumper" :total="total">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal='false' :center='true' @close='closeDialog'>
      <div class="eldialog-title">回复留言</div>
      <Reply :item="item" @reply="saveReply" ref="closeD" />
    </el-dialog>
    <el-dialog :visible.sync="showdetail" :close-on-click-modal='false'>
      <div class="eldialog-title">留言详情</div>
      <div class="top">
        <div class="item-title">{{ item.title }}</div>
        <div class="time">{{ item.createTime }}</div>
      </div>
      <div class="item-content">
        {{ item.qcontent }}
      </div>
      <el-divider></el-divider>
      <div class="reply">
        <span>回复：</span>
        {{ item.reply ? item.reply.rcontent : '' }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showdetail = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Reply from '@/components/messageReply'
export default {
  name: 'messageManage',
  data () {
    return {
      messageList: [],
      currentPage: 1,
      limit: '10',
      total: 1,
      selectedList: [],
      dialogVisible: false,
      item: {},
      showdetail: false,
      typeList: [],
      type: '',
      time: 0,
      timer: ''
    }
  },
  components: {
    Reply
  },
  mounted () {
    // this.getList()
    // if (!localStorage.getItem('VerificationBy')) {
    //   this.$router.push({path: '/adminLogin'})
    // }
    if (!this.$route.params.data) {
      this.$router.push({path: '/adminLogin'})
    }
    this.typeList.push({ name: this.$route.params.data, active: false })
    this.chanetype({ name: this.$route.params.data, active: false }, 0)
    this.timer = setTimeout(() => {
      sessionStorage.setItem('VerificationBy', false)
      this.$router.push({path: '/adminLogin'})
    }, 600000)
  },
  methods: {
    // 监测页面是否还在使用
    monitor () {
      // let a = Date.now()
      // if (a - this.time > 600000) {
      //   clearTimeout(this.timer)
      //   this.timer = setTimeout(() => {
      //     sessionStorage.setItem('VerificationBy', false)
      //     this.$router.push({path: '/adminLogin'})
      //   }, 600000)
      // }
    },
    getList () { // 获取留言列表
      let para = {
        page: this.currentPage,
        rows: this.limit,
        isPublish: '2',
        type: this.type
      }
      this.$http.getMessagesList(para).then(res => {
        this.messageList = res.list
        this.total = res.total
        this.currentPage = res.pageNum
      }).catch(err => {
        console.error(err)
      })
    },
    chanetype (item, i) {
      if (item.name === '管理员') {
        this.typeList = [
            { name: '招生', active: false },
            { name: '就业', active: false },
            { name: '教学', active: false },
        { name: '学生工作', active: false },
        { name: '生活服务', active: false },
        { name: '人才招聘', active: false },
        { name: '出国留学', active: false },
        { name: '报考问题咨询', active: false },
        { name: '校长信箱', active: false }
        ]
      } 
       this.typeList.forEach((typeItem, ind) => {
        if (i !== ind) {
          this.typeList[ind].active = false
        } else {
          this.typeList[ind].active = true
        }
      })
      
      this.type = item.name
      this.getList()
    },
    handleSizeChange (e) {
      // console.log(e)
      this.limit = e
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange (e) {
      this.currentPage = e
      this.getList()
    },
    handleSelectionChange (e) {
      console.log(e)
      this.selectedList = e
    },
    remove (item) { // 删除某一个
      this.$http.remove(item.id).then(res => {
        if (res.success) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          this.getList()
        }
      }).catch(err => {
        console.error(err)
      })
    },
    removeSelected () { // 删除选中的
      let idList = []
      if (this.selectedList.length > 0) {
        this.selectedList.forEach((item) => {
          idList.push(item.id)
        })
        this.$http.removeSelected({ids: idList.join(',')}).then(res => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            })
            this.getList()
          }
        }).catch(err => {
          console.error(err)
        })
      }
    },
    publishSelected () { // 显示选中的
      let idList = []
      if (this.selectedList.length > 0) {
        this.selectedList.forEach((item) => {
          idList.push(item.id)
        })
        this.$http.publishSelected({ids: idList.join(',')}).then(res => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            })
            this.getList()
          }
        }).catch(err => {
          console.error(err)
        })
      }
    },
    unpublishSelected () { // 显示选中的
      let idList = []
      if (this.selectedList.length > 0) {
        this.selectedList.forEach((item) => {
          idList.push(item.id)
        })
        this.$http.unpublishSelected({ids: idList.join(',')}).then(res => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success'
            })
            this.getList()
          }
        }).catch(err => {
          console.error(err)
        })
      }
    },
    reply (item) { // 回复编辑
      this.item = item
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.closeD.replyTexts()
      })
    },
    closeDialog () {
      this.$refs.closeD.closeDs()
    },
    saveReply (item) { // 提交留言回复
      let para = {
        questionId: item.id,
        rContent: item.rcontent,
        username: item.username,
        telephone: item.telephone,
        isPublish: item.isPublish
      }
      this.$http.saveReply(para).then(res => {
        // console.log(res)
        if (res.success) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          })
          this.getList()
          this.dialogVisible = false
        }
      }).catch(err => {
        console.error(err)
      })
    },
    showDetail (item) { // 查看详情
      this.item = item
      this.showdetail = true
    }
  }
}
</script>
<style>

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.eldialog-title {
  margin-top: -35px;
  font-size: 18px;
  margin-bottom: 30px;
}

$color: #6e348b;

.el-card>>>.el-card__header>.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.title {
  color: $color;
  font-size: 24px;
  font-weight: bold;
  margin-right: 20px;
}

.typeList {
  display: flex;
  font-size: 14px;
  cursor: pointer;

  span.active {
    color: #bd79df;
  }

  &>div:last-child {
    .el-divider--vertical {
      display: none;
    }
  }
}

.cell i {
  font-size: 1.3em;
  margin: 5px;
  cursor: pointer;
}

.el-pagination {
  text-align: center;
  margin-top: 20px;
}

.el-table--border {
  margin-top: 20px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .item-title {
    font-weight: bold;
  }

  .time {
    color: #909399;
    font-size: 14px;
  }
}

.item-content {
  color: #606266;
  font-size: 14px;
}

.reply {
  color: #606266;
  font-size: 14px;

  span {
    color: #333;
    font-weight: bold;
  }
}

@media (max-width: 768px) {
  .container /deep/.el-dialog--center {
    width: 100vw;
  }

  .container /deep/ .el-dialog {
    width: 100vw;
  }
}

@media (min-width: 769px) {
  .container /deep/ .el-dialog {
    width: 45%;
  }

  .container /deep/.el-dialog--center {
    width: 45%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/messageManage.vue


// WEBPACK FOOTER //
// src/views/messageManage.vue